<template>
  <div id="product-parameter" class="pl-5 pr-5 pt-3 pb-3 rounded-3 text-white">
    <h1>{{ $t('components.product-parameter.title') }}</h1>
    <el-form ref="dataForm" :model="productState" label-position="top" status-icon>
      <div v-if="!hideInfo" class="row ml-0 mr-0">
        <div class="col col-lg-7">
          <template v-if="!isEditable">
            <h2 class="row">{{ productState.name }}</h2>
          </template>
          <template v-else>
            <el-form-item
              prop="name"
              required
              class="form-text text-white"
              :rules="{
                required: true,
                message: $t('error.vuelidate.required'),
                trigger: 'blur',
              }"
            >
              <el-input v-model="productState.name" placeholder="Title" type="text" :disabled="isUpdating" />
            </el-form-item>
          </template>

          <p v-if="!isEditable" id="product-details-info-text" class="row form-text text-white">
            <span class="d-block mb-3">
              {{ productState.description }}
            </span>

            <button v-if="Boolean(videoMetadata.fileUrl)" type="button" class="btn btn-warning d-flex" @click="handleShowVideo(videoMetadata)">
              Watch Video
            </button>
          </p>

          <el-form-item
            v-else
            prop="description"
            required
            class="form-text text-white"
            :rules="{
              required: true,
              message: $t('error.vuelidate.required'),
              trigger: 'blur',
            }"
          >
            <el-input v-model="productState.description" placeholder="Description" :rows="4" type="textarea" :disabled="isUpdating" />
          </el-form-item>

          <div v-if="isEditable" class="btn-update-wrapper">
            <button type="button" class="btn btn-primary ml-auto" :disabled="isUpdating" @click="updateProduct">Update</button>
          </div>
        </div>
        <div class="col col-lg-1">
          <el-icon v-if="isAuthenticated" @click="toggleEditable">
            <font-awesome-icon v-if="isEditable" icon="close" />
            <font-awesome-icon v-else icon="edit" />
          </el-icon>
          <!--<el-icon @click="toggleEditable" v-else>
              <font-awesome-icon icon="edit" />
            </el-icon>-->
        </div>
        <div class="col col-lg-4 d-flex justify-content-center">
          <slot></slot>
        </div>
      </div>
    </el-form>

    <div class="row">
      <product-parameter-deformation
        v-if="product.name.replace(/\s/g, '').toLowerCase().includes('withdeformation')"
        :key="product.productId"
        :order="properties[0]"
        :product="product"
        :readonly="readonly"
        @info-button-clicked="showProductParameterTemplateInfoDialog"
        @update-properties="(newProperties: any) => $emit('updateProperties', newProperties)"
      />

      <product-parameter-cover
        v-if="product.type.name.toLowerCase() == 'covers' && !product.name.replace(/\s/g, '').toLowerCase().includes('withdeformation')"
        :order="properties[0]"
        :product="product"
        :readonly="readonly"
        @zip-changed="(zip: any) => $emit('zipChanged', zip)"
        @info-button-clicked="showMeasurementInfoModalDialog"
        @scan-file-changed="selected"
      />
      <product-parameter-brace
        v-if="product.type.name.toLowerCase() == 'brace' && !product.name.replace(/\s/g, '').toLowerCase().includes('withdeformation')"
        :order="properties[0]"
        :product="product"
        :readonly="readonly"
        @zip-changed="(zip: any) => $emit('zipChanged', zip)"
        @info-button-clicked="showMeasurementInfoModalDialog"
        @scan-file-changed="selected"
      />
      <!-- TODOS: ADJUST IF PROPS -->
      <product-parameter-template
        v-if="product.name.replace(/\s/g, '').toLowerCase().includes('phase1')"
        :key="product.productId"
        :order="properties[0]"
        :product="product"
        :readonly="readonly"
        @info-button-clicked="showProductParameterTemplateInfoDialog"
        @update-properties="(newProperties: any) => $emit('updateProperties', newProperties)"
      />
      <!-- TODOS: ADJUST IF PROPS -->
      <product-parameter-orthesis
        v-if="product.type.name.toLowerCase() == 'orthesen' && !product.name.replace(/\s/g, '').toLowerCase().includes('phase1')"
        :order="properties[0]"
        :product="product"
        :readonly="readonly"
        @zip-changed="(zip: any) => $emit('zipChanged', zip)"
        @scan-file-changed="selected"
      />
      <!--<product-parameter-cuboid
        v-if="product.type.name.toLowerCase() == 'möbel' ||
              product.type.name.toLowerCase() == 'sonstige' ||
              product.type.name.toLowerCase() == 'hütten'"
        :order="properties[0]"
      />
      -->
      <product-parameter-balcony v-if="product.type.name.toLowerCase() == 'balkone'" :order="properties[0]" :readonly="readonly" />
      <product-parameter-fence-sun
        v-if="product.type.name.toLowerCase() == 'fence'"
        :order="properties[0]"
        :readonly="readonly"
        :product="product.type.name.toLowerCase()"
      />
      <product-parameter-fence
        v-if="product.type.name.toLowerCase() == 'zäune'"
        :order="properties[0]"
        :readonly="readonly"
        :product="product.type.name.toLowerCase()"
      />
      <product-parameter-linear-light
        v-if="product.type.name.toLowerCase() == 'lineare beleuchtung'"
        :order="properties[0]"
        :is-hanging-light="product.name.toLowerCase() === LinearLightNameType.hanging.toLowerCase()"
        :is-surface-mounted-light="product.name.toLowerCase() === LinearLightNameType.surfaceMounted.toLowerCase()"
        :readonly="readonly"
      />
      <product-parameter-bathtub v-if="product.type.name.toLowerCase() == 'duschen und bäder'" :order="properties[0]" :readonly="readonly" />

      <div id="measurement-info" class="modal fade" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-xl">
          <div id="info-content" class="modal-content">
            <div id="info-header" class="modal-header border-bottom-0 bg-transparent">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body p-0 bg-grey">
              <measurement-info-card>
                <div class="row">
                  <div v-if="selectedContent == 'content1'" class="col-12">
                    <h2>{{ $t('components.order-form.scope-top') }}</h2>
                    <div class="row">
                      <div id="txtcol" class="col-md-6">
                        <p class="form-text text-black">
                          {{ $t('components.product-parameter.measurementsInfo.scope.top.info') }}
                        </p>
                        <ul style="list-style-type: disc; padding-left: 20px">
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.scope.bullet1') }}
                          </li>
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.scope.bullet2') }}
                          </li>
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.scope.bullet3') }}
                          </li>
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.scope.bullet4') }}
                          </li>
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.scope.bullet5') }}
                          </li>
                        </ul>
                      </div>
                      <div id="imgcol" class="col-md-6">
                        <img id="infoimg" class="img-fluid" src="@/assets/images/covers/scope_calve.png" />
                      </div>
                    </div>
                  </div>
                  <div v-if="selectedContent == 'content2'" class="col-12">
                    <h2>{{ $t('components.order-form.height') }}</h2>
                    <div class="row">
                      <div id="txtcol" class="col-md-6">
                        <div v-if="product.name.toLowerCase().includes('unterschenkel')">
                          <p class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.height-leg.upper.info') }}
                          </p>
                          <ul style="list-style-type: disc; padding-left: 20px">
                            <li class="form-text text-black">
                              {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet1') }}
                            </li>
                            <li class="form-text text-black">
                              {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet2') }}
                            </li>
                            <li class="form-text text-black">
                              {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet3') }}
                            </li>
                            <li class="form-text text-black">
                              {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet4') }}
                            </li>
                            <li class="form-text text-black">
                              {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet5') }}
                            </li>
                          </ul>
                        </div>
                        <div v-else>
                          <p class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.height-leg.lower.info') }}
                          </p>
                          <ul style="list-style-type: disc; padding-left: 20px">
                            <li class="form-text text-black">
                              {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet1') }}
                            </li>
                            <li class="form-text text-black">
                              {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet2') }}
                            </li>
                            <li class="form-text text-black">
                              {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet3') }}
                            </li>
                            <li class="form-text text-black">
                              {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet4') }}
                            </li>
                            <li class="form-text text-black">
                              {{ $t('components.product-parameter.measurementsInfo.height-leg.bullet5') }}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div id="imgcol" class="col-md-6">
                        <img
                          v-if="product.name.toLowerCase().includes('unterschenkel')"
                          id="infoimg"
                          class="img-fluid"
                          src="@/assets/images/covers/height_lower_leg.png"
                        />
                        <img v-else id="infoimg" class="img-fluid" src="@/assets/images/covers/height_upper_leg.png" />
                      </div>
                    </div>
                  </div>
                  <div v-if="selectedContent == 'content3'" class="col-12">
                    <h2>{{ $t('components.order-form.scope-bottom') }}</h2>
                    <div class="row">
                      <div id="txtcol" class="col-md-6">
                        <p class="form-text text-black">
                          {{ $t('components.product-parameter.measurementsInfo.scope.bottom.info') }}
                        </p>
                        <ul style="list-style-type: disc; padding-left: 20px">
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.scope.bullet1') }}
                          </li>
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.scope.bullet2') }}
                          </li>
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.scope.bullet3') }}
                          </li>
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.scope.bullet4') }}
                          </li>
                          <li class="form-text text-black">
                            {{ $t('components.product-parameter.measurementsInfo.scope.bullet5') }}
                          </li>
                        </ul>
                      </div>
                      <div id="imgcol" class="col-md-6">
                        <img id="infoimg" class="img-fluid" src="@/assets/images/covers/scope_ankle.png" />
                      </div>
                    </div>
                  </div>
                </div>
              </measurement-info-card>
            </div>
          </div>
        </div>
      </div>

      <div id="product-parameter-info" class="modal fade" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-xl">
          <div id="info-content" class="modal-content">
            <div id="info-header" class="modal-header border-bottom-0 bg-transparent">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div id="info-body" class="modal-body p-0">
              <measurement-info-card>
                <div class="row">
                  <div v-if="Boolean(selectedContent)" class="col-12 text-center">
                    <img id="infoimg" class="img-fluid" :src="selectedContent || ''" />
                  </div>
                </div>
              </measurement-info-card>
            </div>
          </div>
        </div>
      </div>

      <!-- Button -->
      <div class="row d-flex justify-content-center mb-5 mt-2">
        <button type="button" class="btn btn-primary" @click="$emit('buttonClicked', selectedBodyAttribute)">
          {{ $t('components.product-parameter.startConfigurator') }}
        </button>
      </div>
    </div>
  </div>

  <!-- Video preview modal ... -->
  <PreviewRendererDetails ref="previewRendererDetails" :can-download="true" :can-remove="true" />
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import { ElForm } from 'element-plus';

import { Product } from '@/types/api/Model/Product';
import ProductParameterCover from '@/components/productParameters/ProductParameterCover.vue';
import ProductParameterCuboid from '@/components/productParameters/ProductParameterCuboid.vue';
import * as productService from '@/services/api/productService';
import { Body_Attribute } from '@/types/api/Patient/BodyAttribute';
import { LinearLightNameType } from '@/types/enum/order';
import ProductParameterBalcony from '@/components/productParameters/ProductParameterBalcony.vue';
import ProductParameterFence from '@/components/productParameters/ProductParameterFence.vue';
import ProductParameterOrthesis from '@/components/productParameters/ProductParameterOrthesis.vue';
import ProductParameterBrace from '@/components/productParameters/ProductParameterBrace.vue';
import ProductParameterTemplate from '@/components/productParameters/ProductParameterTemplate.vue';
import ProductParameterLinearLight from '@/components/productParameters/ProductParameterLinearLight.vue';
import ProductParameterBathtub from '@/components/productParameters/ProductParameterBathtub.vue';
import MeasurementInfoCard from '@/components/productParameters/MeasurementInfoCard.vue';
import { removeWordFromString } from '@/utils/formBuilder';
import { TableField } from '@/utils/file';
import PreviewRendererDetails from '@/components/features/previewRenderer/PreviewRendererDetails.vue';
import ProductParameterFenceSun from './ProductParameterFenceSun.vue';
import ProductParameterDeformation from './ProductParameterDeformation.vue';

@Component({
  components: {
    MeasurementInfoCard,
    ProductParameterCover,
    ProductParameterCuboid,
    ProductParameterBalcony,
    ProductParameterFence,
    ProductParameterFenceSun,
    ProductParameterOrthesis,
    ProductParameterBrace,
    ProductParameterTemplate,
    ProductParameterLinearLight,
    ProductParameterBathtub,
    PreviewRendererDetails,
    ProductParameterDeformation,
  },
  emits: ['buttonClicked', 'zipChanged', 'infoButtonClicked', 'updateProperties', 'productUpdated'],
})
@Component
export default class ProductParamter extends Vue {
  @Prop() product!: Product;
  @Prop() isAuthenticated?: boolean;
  @Prop() properties!: any[];
  @Prop({ default: false }) readonly!: boolean;
  @Prop({ default: false }) hideInfo!: boolean;
  @Prop() videoMetadata!: TableField;

  selectedBodyAttribute: Body_Attribute | null = null;

  isEditable = false;
  isUpdating = false;
  productState: {
    name: string;
    description: string;
  } = {
    name: '',
    description: '',
  };

  private measurementInfoModalDialog: any = null;
  private productParameterTemplateDialog: any = null;
  selectedContent: string | null = null;

  LinearLightNameType = LinearLightNameType;

  // Truncate 'phase1' word in title string
  get productTitle(): string {
    return removeWordFromString(this.product?.name, 'phase1', 20);
  }

  selected(bodyAttribute: Body_Attribute): void {
    this.selectedBodyAttribute = bodyAttribute as Body_Attribute;
  }

  showMeasurementInfoModalDialog(content: string | null): void {
    this.selectedContent = content;
    this.measurementInfoModalDialog.show();
  }

  showProductParameterTemplateInfoDialog(content: string | null): void {
    this.selectedContent = content;
    this.productParameterTemplateDialog.show();
  }

  toggleEditable() {
    if (this.isUpdating) return;
    this.isEditable = !this.isEditable;
  }

  updateProduct() {
    this.isUpdating = true;
    const dataForm = this.$refs.dataForm as typeof ElForm;
    dataForm?.validate(async (valid: any) => {
      if (!valid) return;
      const newName = this.productState.name + ' phase1';
      productService
        .updateProduct({
          productId: this.product.productId,
          name: newName,
          description: this.productState.description,
        })
        .then(() => {
          this.isUpdating = false;
          this.toggleEditable();
          this.$emit('productUpdated', {
            productId: this.product.productId,
            name: newName,
          });
        })
        .catch((err) => {
          this.isUpdating = false;
          this.toggleEditable();
          console.error('[ERROR UPDATE PRODUCT]: ', err);
        });
    });
  }

  handleShowVideo(payload: TableField): void {
    const rendererDetails = this.$refs.previewRendererDetails as PreviewRendererDetails;

    if (!payload || !rendererDetails) return;
    
    const { filename, fileType, fileUrl } = payload;
    rendererDetails.handleShowModal({
      fileName: filename,
      fileType,
      fileUrl,
    });
  }


}
</script>

<style scoped lang="scss">
#product-parameter {
  background: transparent radial-gradient(closest-side at 50% 50%, rgba(75, 75, 75, 0.85) 0%, rgba(0, 0, 0, 0.85) 100%) 0% 0% no-repeat padding-box;
}

#value1-range-text,
#value2-range-text,
#value1,
#value2 {
  margin-top: -0.65rem;
}

#value1,
#value2 {
  padding: 0.5rem;
}

#product-parameter-info-text {
  font-size: 1rem;
}

#measurement-info {
  box-sizing: border-box;
  height: 100%;
  width: 60%;
  position: fixed;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
}

#info-content {
  background-color: transparent;
}

#info-header {
  background-color: transparent;
  z-index: 1;
}

#info-body {
  background-color: rgba(0, 0, 0, 0.85);
  margin-top: -3.6rem;
  z-index: 0;
  display: flex;
  flex-direction: column;
  height: 80%;
  overflow: scroll;
}

.bg-grey {
  background-color: rgba(0, 0, 0, 0.85);
}

#infoimg {
  max-height: 330px;
  max-width: auto;
}

#txtcol {
  overflow: auto;
  flex: 1;
}

#imgcol {
  overflow: auto;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-form {
  width: 100%;
  i {
    width: auto;
    cursor: pointer;
    font-size: 16px;
  }
}

.btn-update-wrapper {
  display: flex;
  justify-content: flex-end;
}

@media only screen and (max-width: 1000px) {
  #txtcol,
  #imgcol {
    width: 100%;
  }

  #infoimg {
    margin-left: 0;
  }
}
</style>
